module.exports = __webpack_public_path__ + "media/bootstrap-icons/image-8aa9aa02.svg";